import { Page } from '@/core/architecture'

import { ConsoleDmRoomsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEvents Page
 * Implemented as a practical sample.
 */
export const ConsoleDmRooms: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleDmRoomsTemplate state={state} {...actions} />
}
